import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledTuningContainer = styled.div`
	margin-top: 20px;
`;

const StyledTable = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	gap: 14px;
	margin-top: 20px;
`;

const StyledRow = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;

	& > ${Text}:first-child {
		font-size: 16px;
		color: #ffffff;
		opacity: 0.25;
	}

	& > ${Text}:last-child {
		font-size: 16px;
		color: #ffffff;
	}
`;

const StyledPriceValue = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;

	${Text} {
		font-weight: 700;
		font-size: 16px;
		color: #ffffff;
	}

	.currency-icon {
		opacity: 0.5;
	}
`;

const StyledDiagButtonContainer = styled.div`
	margin-top: 30px;
`;

const StyledButtonsContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 20px;
	margin-top: 20px;
`;

const StyledButtonContent = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 10px;

	img {
		width: 20px;
		height: 20px;
		user-select: none;
		pointer-events: none;
	}
`;

export {
	StyledButtonContent,
	StyledButtonsContainer,
	StyledDiagButtonContainer,
	StyledPriceValue,
	StyledRow,
	StyledTable,
	StyledTuningContainer,
};
